import { CUSTOM_EVENTS } from '../events';
import {
    businessPropertyService,
    businessService,
    categoryService,
    discountService,
    itemService,
    measurementUnitService,
    modifierService,
    paymentMethodService,
    paymentRestrictionService,
    pricingGroupService,
    registerConfigurationService,
    staffService,
    taxService,
} from '../services';
import { FirestoreChangeTracker } from './change-tracker';

export const firestoreChangeTracker = new FirestoreChangeTracker({
    staff: () => staffService.fetchAndBulkUpsert(),
    businessProperty: () => businessPropertyService.fetchAndUpdate(),
    taxes: () => taxService.fetchAndBulkUpsert(),
    paymentMethod: () => paymentMethodService.fetchAndBulkUpsert(),
    paymentsGroups: () => paymentRestrictionService.fetchAndBulkUpsert(),
    business: () => businessService.fetchAndUpdate(),
    registerConfiguration: () => registerConfigurationService.fetchAndUpdate(),
    receiptConfiguration: () => registerConfigurationService.fetchAndUpdate(),
    invoiceConfiguration: () => registerConfigurationService.fetchAndUpdate(),
    branch: async () => {
        await Promise.all([
            businessService.fetchAndUpdate(),
            registerConfigurationService.fetchAndUpdate(),
        ]);
    },
    items: async (lastSyncTime) => {
        await itemService.fetchAndBulkUpsert(lastSyncTime);
    },
    categories: (lastSyncTime) =>
        categoryService.fetchAndBulkUpsert(lastSyncTime),
    measurementUnits: (lastSyncTime) =>
        measurementUnitService.fetchAndBulkUpsert(lastSyncTime),
    discounts: (lastSyncTime) =>
        discountService.fetchAndBulkUpsert(lastSyncTime),
    pricingGroups: (lastSyncTime) =>
        pricingGroupService.fetchAndBulkUpsert(lastSyncTime),
    collectionAccountTransaction: async () => {
        globalThis.window.dispatchEvent(
            new CustomEvent(CUSTOM_EVENTS.COLLECTION_ACCOUNT_TRANSACTION),
        );
    },
    modifierGroups: (lastSyncTime) =>
        modifierService.fetchAndBulkUpsert(lastSyncTime),
});
